import React, {useContext, useEffect, useRef} from "react";
import {InlineTextInput} from "@advthreat/ribbon-components";
import {useDispatch, useSelector} from "react-redux";
import {patchIncident} from "store/features/incidentDetailSlice";
import {selectIncidentDetail} from "store/selectors";
import {IncidentDetailContext} from "../../contexts/IncidentDetailContext";
import css from "./IncidentTitle.module.scss";

// @todo magna-fix Needs correct Edit icon.
const IncidentTitle = () => {
  const titleRef = useRef(null);
  const dispatch = useDispatch();
  const incident = useSelector(selectIncidentDetail);
  const {id: incidentId, title} = incident;

  const {changeEditableTitleId, editableTitleId} = useContext(
    IncidentDetailContext
  );

  useEffect(() => {
    if (incidentId === editableTitleId && titleRef.current !== null) {
      titleRef.current.editMode();
    }
  }, [titleRef, editableTitleId, incidentId]);

  const saveTitle = (newValue, {callback}) => {
    dispatch(
      patchIncident({
        incidentId,
        patch: {title: newValue}
      })
    );
    callback(true);
  };
  return (
    <div className={css.titleEditor} data-testid={"IncidentTitle-Container"}>
      <InlineTextInput
        id="title"
        name="title"
        required={true}
        value={title}
        onChange={saveTitle}
        preventEmpty={true}
        large
        onBlur={() => changeEditableTitleId("")}
        ref={titleRef}
      />
    </div>
  );
};

export default IncidentTitle;
